var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { EJComponentDecorator } from '@syncfusion/ej2-vue-base';
let AggregateColumnsDirective = class AggregateColumnsDirective extends Vue {
    render() {
        return;
    }
};
AggregateColumnsDirective = __decorate([
    EJComponentDecorator({})
], AggregateColumnsDirective);
export { AggregateColumnsDirective };
export const AggregateColumnsPlugin = {
    name: 'e-columns',
    install(Vue) {
        Vue.component(AggregateColumnsPlugin.name, AggregateColumnsDirective);
    }
};
/**
 * `e-aggregate->e-column` directive represent a aggregate column of the VueJS Grid.
 * ```vue
 * <ejs-grid :dataSource='data' allowPaging='true' allowSorting='true'>
 *   <e-columns>
 *     <e-column field='ID' width='100'/>
 *     <e-column field='name' headerText='Name' width='100'/>
 *   </e-columns>
 *   <e-aggregates>
 *     <e-aggregate>
 *       <e-columns>
 *         <e-column field='ID' type='Min'/>
 *       </e-columns>
 *      </e-aggregate>
 *    </e-aggregates>
 * </ejs-grid>
 * ```
 */
let AggregateColumnDirective = class AggregateColumnDirective extends Vue {
    render() {
        return;
    }
};
AggregateColumnDirective = __decorate([
    EJComponentDecorator({})
], AggregateColumnDirective);
export { AggregateColumnDirective };
export const AggregateColumnPlugin = {
    name: 'e-column',
    install(Vue) {
        Vue.component(AggregateColumnPlugin.name, AggregateColumnDirective);
    }
};
